import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { LOADING_LABELS } from '@kexiaoman/shared';
import { adminApi, ApiError } from '@/lib/api';

export function LoginPage() {
  const navigate = useNavigate();
  const [token, setToken] = useState('');

  const login = useMutation({
    mutationFn: (t: string) => adminApi.login(t),
    onSuccess: () => {
      const next = new URLSearchParams(window.location.search).get('next') || '/';
      navigate(next, { replace: true });
    },
  });

  const errorMessage =
    login.error instanceof ApiError
      ? login.error.status === 401
        ? '访问令牌不正确'
        : login.error.message
      : login.error
        ? String(login.error)
        : null;

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>喜爱云 · 管理后台</CardTitle>
          <CardDescription>输入 ADMIN_ACCESS_TOKEN 登录</CardDescription>
        </CardHeader>
        <CardContent>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (token.trim()) login.mutate(token.trim());
            }}
            className="space-y-3"
          >
            <Input
              type="password"
              autoFocus
              autoComplete="off"
              placeholder="64 字符的 access token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              disabled={login.isPending}
            />
            {errorMessage && <p className="text-sm text-destructive">{errorMessage}</p>}
            <Button type="submit" className="w-full" disabled={login.isPending || !token.trim()}>
              {login.isPending ? LOADING_LABELS.signingIn : '登录'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
